<div class="animate__animated animate__fadeInUp custom-animate" style="color: #000000; font-weight: 400; font-size: 12px; padding: 0; margin: 0;" *ngIf="selectDatesTitle !== 'Select date'">Select date</div>
<button class="custom-button" 
        (click)="toggleContainer()"
        [ngClass]="{'border-active': showContainer}"
        [disabled]="disabled"
        [ngStyle]="{'margin-top': selectDatesTitle === 'Select date' ? '22px' : '0px'}"
        >
    <span class="button-text" [ngStyle]="disabled ?{'color': '#d6d6d6'} :{'color': '#212121'}">{{selectDatesTitle}}</span>
    <span class="button-icons" [ngStyle]="disabled ?{'color': '#d6d6d6'} :{'color': '#212121'}">
        <i *ngIf="!showContainer" class="material-icons">arrow_drop_down</i>
        <i *ngIf="showContainer" class="material-icons-a">arrow_drop_up</i>
    </span>
</button>


<div *ngIf="showContainer" [@showHide]="showContainer ? 'show' : 'hide'">
    <div #treeContainer class="checkbox-tree-container mat-elevation-z8" (wheel)="onScroll($event)">
    
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
            <mat-tree-node
            *matTreeNodeDef="let node"
            matTreeNodeToggle
            matTreeNodePadding
            >
            <button mat-icon-button disabled></button>
            <mat-checkbox
                class="checklist-leaf-node"
                [checked]="checklistSelection.isSelected(node)"
                (change)="todoLeafItemSelectionToggle(node)"
                >{{node.item}}
            </mat-checkbox>
            </mat-tree-node>
        
            <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
            <button
                mat-icon-button
                matTreeNodeToggle
                [attr.aria-label]="'Toggle ' + node.item"
            >
                <mat-icon class="mat-icon-rtl-mirror">
                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
            </button>
            <mat-checkbox
                [checked]="descendantsAllSelected(node)"
                [indeterminate]="descendantsPartiallySelected(node)"
                (change)="todoItemSelectionToggle(node)"
                >{{node.item}}</mat-checkbox
            >
            </mat-tree-node>
        </mat-tree>

    </div>
</div>

  